<template>
    <div class="form">
        <Form ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="项目名称"
                    prop="projName">
                    <Input v-model="info.projName"
                        placeholder
                        :maxlength="50"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="备案名"
                    prop="recordName">
                    <Input v-model="info.recordName"
                        placeholder
                        :maxlength="50"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="物业类型"
                    prop="propertyType">
                    <Select v-model="propertyType"
                        transfer
                        placeholder="请选择"
                        multiple
                        :readonly="readonly">
                        <Option v-for="(item, index) in propertyTypeList"
                            :value="item.id"
                            :key="index">{{item.text}}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="所在城市"
                    prop="city">
                    <Select v-model="info.city"
                        transfer
                        placeholder
                        :readonly="readonly">
                        <Option v-for="(item, index) in projCityList"
                            :value="item.id"
                            :key="index">{{item.text}}</Option>
                    </Select>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="项目特色"
                    prop="features">
                    <Input v-model="info.features"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="建筑类别"
                    prop="buildType">
                    <Input v-model="info.buildType"
                        placeholder
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="装修状况"
                    prop="decorationStatus">
                    <Select v-model="info.decorationStatus"
                        transfer
                        placeholder
                        :readonly="readonly">
                        <Option v-for="(item, index) in decorationStatusList"
                            :value="item.id"
                            :key="index">{{item.text}}</Option>
                    </Select>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="产权年限"
                    prop="propertyRight">
                    <Input v-model="info.propertyRight"
                        placeholder
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="开发商"
                    prop="developer">
                    <Input v-model="info.developer"
                        placeholder
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="项目地址"
                    prop="projAddr">
                    <Input v-model="info.projAddr"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="咨询电话"
                    prop="mobile">
                    <Input v-model="info.mobile"
                        placeholder
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="销售状态"
                    prop="saleStatus">
                    <Select v-model="info.saleStatus"
                        transfer
                        placeholder
                        :readonly="readonly">
                        <Option v-for="(item, index) in saleStatusList"
                            :value="item.id"
                            :key="index">{{item.text}}</Option>
                    </Select>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="售楼地址"
                    prop="saleAddr">
                    <Input v-model="info.saleAddr"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="占地面积"
                    prop="landArea">
                    <input-number v-model="info.landArea"
                        placeholder
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="建筑面积"
                    prop="buildArea">
                    <input-number v-model="info.buildArea"
                        placeholder
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="容积率"
                    prop="plotRatio">
                    <input-number v-model="info.plotRatio"
                        placeholder
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="绿化率"
                    prop="greenRatio">
                    <input-number v-model="info.greenRatio"
                        placeholder
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="停车位"
                    prop="parkingSpace">
                    <Input v-model="info.parkingSpace"
                        placeholder
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="楼栋总数"
                    prop="floorNum">
                    <input-number v-model="info.floorNum"
                        placeholder
                        :readonly="readonly"
                        :allowDecimal="false"></input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="总户数"
                    prop="houseNum">
                    <Input v-model="info.houseNum"
                        placeholder
                        :readonly="readonly"
                        :allowDecimal="false"></Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="物业公司"
                    prop="propertyCompany">
                    <Input v-model="info.propertyCompany"
                        placeholder
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                <FormItem label="物业费"
                    prop="propertyFee">
                    <input-number v-model="info.propertyFee"
                        placeholder
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="均价"
                    prop="averagePrice">
                    <input-number v-model="info.averagePrice"
                        placeholder
                        :readonly="readonly"></input-number>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="楼层状况"
                    prop="floorCondition">
                    <Input v-model="info.floorCondition"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="银行"
                    prop="bank">
                    <Input :readonly="readonly"
                        v-model="info.bank"
                        placeholder
                        type="textarea"
                        :rows="2"
                        :maxlength="1000"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="社区"
                    prop="community">
                    <Input v-model="info.community"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="幼儿园"
                    prop="kindergarten">
                    <Input v-model="info.kindergarten"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="邮政"
                    prop="postal">
                    <Input v-model="info.postal"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="医院"
                    prop="hospital">
                    <Input v-model="info.hospital"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="超市"
                    prop="supermarket">
                    <Input v-model="info.supermarket"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="学校"
                    prop="school">
                    <Input v-model="info.school"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="交通"
                    prop="traffic">
                    <Input v-model="info.traffic"
                        placeholder
                        :maxlength="100"
                        :readonly="readonly"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="项目简介"
                    prop="description">
                    <Input :readonly="readonly"
                        v-model="info.description"
                        placeholder
                        type="textarea"
                        :rows="2"
                        :maxlength="1000"></Input>
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                <FormItem label="其他"
                    prop="remark">
                    <Input :readonly="readonly"
                        v-model="info.remark"
                        placeholder
                        type="textarea"
                        :rows="2"
                        :maxlength="1000"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { projAdd, projUpdate, projView } from '@/api/proj-manager'
import Dict from '@/utils/dict'

export default {
    name: 'FormProjForm',
    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {},

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            info: {
                id: this.id,
                projName: '', // 项目名称
                recordName: '', // 备案名
                propertyType: '', // 物业类型
                city: '', // 所在城市
                features: '', // 项目特色
                buildType: '', // 建筑类别
                decorationStatus: '', // 装修状况
                propertyRight: '', // 产权年限
                developer: '', // 开发商
                projAddr: '', // 项目地址
                mobile: '', // 咨询电话
                saleStatus: '', // 销售状态
                saleAddr: '', // 售楼地址
                landArea: '', // 占地面积
                buildArea: '', // 建筑面积
                plotRatio: '', // 容积率
                greenRatio: '', // 绿化率
                parkingSpace: '', // 停车位
                floorNum: '', // 楼栋总数
                houseNum: '', // 总户数
                propertyCompany: '', // 物业公司
                propertyFee: '', // 物业费
                averagePrice: '', // 均价
                floorCondition: '', // 楼层状况
                bank: '', // 银行
                community: '', // 社区
                kindergarten: '', // 幼儿园
                postal: '', // 邮政
                hospital: '', // 医院
                supermarket: '', // 超市
                school: '', // 学校
                traffic: '', // 交通
                description: '', // 项目简介
                remark: '', // 其他
                ver: '' // 版本号
            },
            dict: {
                propertyType: Dict.NULL,
                decorationStatus: Dict.NULL,
                saleStatus: Dict.NULL,
                projCity: Dict.NULL
            },
            loading: false
        }
    },

    computed: {
        canSave(){
            return this.id ? this.$can("update") : this.$can("add")
        },

        readonly(){
            return this.loading || !this.canSave
        },

        propertyType: {
            get() {
                return this.info.propertyType ? this.info.propertyType.split(",") : []
            },

            set(val) {
                this.info.propertyType = val.join(",")
            }
        },

        ruleValidate() {
            return {
                projName: [{ required: true, message: '项目名称必填' }],
                recordName: [{ required: true, message: '备案名必填' }],
                propertyType: [{ required: true, message: '物业类型必填' }],
                city: [{ required: true, message: '所在城市必填' }],
                saleStatus: [{ required: true, message: '销售状态必填' }]
            }
        },

        propertyTypeList() {
            return this.dict.propertyType.val()
        },
        decorationStatusList() {
            return this.dict.decorationStatus.val()
        },
        saleStatusList() {
            return this.dict.saleStatus.val()
        },
        projCityList() {
            return this.dict.projCity.val()
        },
    },

    methods: {
        fetch() {
            if (this.id) {
                return projView(this.id)
            } else {
                return Promise.resolve()
            }
        }
    },

    mounted() {
        var $info = this.$refs.info,
            btns = [{ type: "default", text: "关闭", name: "cancel" }]

        this.loading = true

        // 按钮定制
        if (this.canSave) {
            btns.unshift({ type: "primary", text: "保存", name: "confirm" })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([
                    Dict.get(['property_type', 'decoration_status', 'sale_status', 'proj_city']),
                    this.fetch()
                ])
                .then(args => {
                    var [dictGroup, view] = args
                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name] || Dict.NULL
                    })
                    if (view) {
                        var viewData = view.data.entity
                        Object.keys(this.info).forEach(
                            name => (this.info[name] = viewData[name])
                        )
                    }
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    this.loading = true
                    var formData = Object.assign({}, this.info)
                    if (this.id) {
                        return projUpdate(formData)
                    } else {
                        return projAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => (options.closeModal = false))
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    }
}
</script>
<style lang="less"
    scoped>
</style>